module.exports = {
  tag: require('./flv-tag'),
  Transmuxer: require('./transmuxer'),
  getFlvHeader: require('./flv-header')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mux.js/lib/flv/index.js
// module id = sdx6
// module chunks = 2